var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"pb-4":"","pt-4":""}},[_c('h3',[_vm._v("Вы можете бесплатно восстановить "+_vm._s(_vm.freeRecoveries)+" КБМ.")]),_vm._v(" "),(!_vm.freeRecoveries)?_c('h4',[_vm._v("Оформите три полиса и получите бесплатное восстановление! Уже оформлено "+_vm._s(_vm.policiesSold)+" / 3.")]):_vm._e()])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e26c222","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/kbm/FreeRecoveriesInfo.vue
// module id = S6CI
// module chunks = 0